// import './about.css';
// import { BrowserRouter, Link, NavLink, Outlet, Route, Routes } from "react-router-dom";


// export function AboutPage() {


//     return (
//         <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center main-about " style={{ height: "100vh", width: "100%" }}>
//             <div className="about-page z-1">
//                 <div className='box1-sub'>
//                     <h1>About me</h1>
//                 </div>
//                 <div className='box2-sub'>
//                     <div className='box-mid-bar'>
//                         <span ></span>
//                     </div>
//                     <div className='box-mid-con'>
//                         <span className="text-faded-sub">
//                             I am a motivated MCA student with a focus on Full Stack Development (Java/Web). I have hands-on experience building dynamic and responsive applications using
//                             <span className="skills-highlight"> Microservices, ReactJS, Spring Boot, Apache Kafka, Redis Cache, REST APIs, and Java. </span>
//                             I am eager to apply my skills in real-world projects and continue learning in an immersive and collaborative work environment.
//                         </span>
//                     </div>

//                 </div>
//                 <div className='box3'>
//                     <div className='about-footer-box1'>
//                         <div className='box1-res-footer'>
//                             <NavLink
//                                 to="responsive"
//                                 className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                             >
//                                 <div className='box1-img' >
//                                     <img src="responsive.svg" alt="" style={{ width: "20px", height: "20px" }}  />
//                                 </div>
//                             </NavLink>
//                             <NavLink
//                                 to="expresence"
//                                 className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                             >
//                                 <div className='box2-img'>
//                                     <img src="expresence.svg" alt="" style={{ width: "20px", height: "20px" }}  />
//                                 </div>
//                             </NavLink>
//                         </div>
//                         <div className='box2-res-footer'>
//                             <NavLink
//                                 to="design"
//                                 className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                             >
//                                 <div className='box3-img'>
//                                     <img src="design.svg" alt="" style={{ width: "20px", height: "20px" }}  />
//                                 </div>
//                             </NavLink>
//                             <NavLink
//                                 to="permance"
//                                 className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                             >
//                                 <div className='box4-img'>
//                                     <img src="permance.svg" alt="" style={{ width: "20px", height: "20px" }}  />
//                                 </div>
//                             </NavLink>
//                         </div>
//                     </div>
//                     <div className='about-footer-box2'>
//                         <Outlet />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }





// import { useState } from 'react';
// import './about.css';
// import { ResponsiveSubPage } from './responsive';
// import { ExpresenceSubPage } from './expresence';
// import { DesignSubPage } from './design';
// import { PermanceSubPage } from './permance';

// export function AboutPage() {
//     const [activeTab, setActiveTab] = useState('responsive'); // default tab

//     return (
//         <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center main-about"
//             style={{ height: "100vh", width: "100%" }}>
//             <div className="about-page z-1">

//                 {/* Header */}
//                 <div className='box1-sub'>
//                     <h1>About me</h1>
//                 </div>

//                 {/* Description */}
//                 <div className='box2-sub'>
//                     <div className='box-mid-bar'>
//                         <span></span>
//                     </div>
//                     <div className='box-mid-con'>
//                         <span className="text-faded-sub">
//                             I am a motivated MCA student with a focus on Full Stack Development (Java/Web). I have hands-on experience building dynamic and responsive applications using
//                             <span className="skills-highlight"> Microservices, ReactJS, Spring Boot, Apache Kafka, Redis Cache, REST APIs, and Java. </span>
//                             I am eager to apply my skills in real-world projects and continue learning in an immersive and collaborative work environment.
//                         </span>
//                     </div>
//                 </div>

//                 {/* Footer Tabs */}
//                 <div className='box3'>
//                     <div className='about-footer-box1'>
//                         <div className='box1-res-footer'>
//                             <div
//                                 onClick={() => setActiveTab('responsive')}
//                                 className={`navlink ${activeTab === 'responsive' ? 'active' : ''}`}>
//                                 <div className='box1-img'>
//                                     <img src="responsive.svg" alt="" style={{ width: "20px", height: "20px" }} />
//                                 </div>
//                             </div>
//                             <div
//                                 onClick={() => setActiveTab('expresence')}
//                                 className={`navlink ${activeTab === 'expresence' ? 'active' : ''}`}>
//                                 <div className='box2-img'>
//                                     <img src="expresence.svg" alt="" style={{ width: "20px", height: "20px" }} />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className='box2-res-footer'>
//                             <div
//                                 onClick={() => setActiveTab('design')}
//                                 className={`navlink ${activeTab === 'design' ? 'active' : ''}`}>
//                                 <div className='box3-img'>
//                                     <img src="design.svg" alt="" style={{ width: "20px", height: "20px" }} />
//                                 </div>
//                             </div>
//                             <div
//                                 onClick={() => setActiveTab('permance')}
//                                 className={`navlink ${activeTab === 'permance' ? 'active' : ''}`}>
//                                 <div className='box4-img'>
//                                     <img src="permance.svg" alt="" style={{ width: "20px", height: "20px" }} />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Tab Content */}
//                     <div className='about-footer-box2'>
//                         {activeTab === 'responsive' && <ResponsiveSubPage />}
//                         {activeTab === 'expresence' && <ExpresenceSubPage />}
//                         {activeTab === 'design' && <DesignSubPage />}
//                         {activeTab === 'permance' && <PermanceSubPage />}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }


//---------------------------------------------------


import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // ✅ Added import
import './about.css';
import { ResponsiveSubPage } from './responsive';
import { ExpresenceSubPage } from './expresence';
import { DesignSubPage } from './design';
import { PermanceSubPage } from './permance';

export function AboutPage() {
    const [activeTab, setActiveTab] = useState('responsive');

    // ✅ Animation variants for smooth left-to-right transition
    const tabVariants = {
        initial: { opacity: 0, x: 80 },
        animate: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
        exit: { opacity: 0, x: -80, transition: { duration: 0.4, ease: "easeIn" } },
    };

    return (
        <div
            className="container-fluid bg bg-black d-flex justify-content-center align-items-center main-about"
            style={{ height: "100vh", width: "100%" }}
        >
            <div className="about-page z-1">
                {/* Header */}
                <div className="box1-sub">
                    <h1>About me</h1>
                </div>

                {/* Description */}
                <div className="box2-sub">
                    <div className="box-mid-bar">
                        <span></span>
                    </div>
                    <div className="box-mid-con">
                        <span className="text-faded-sub">
                            I am a motivated MCA student with a focus on Full Stack Development (Java/Web). I have hands-on experience building dynamic and responsive applications using
                            <span className="skills-highlight"> Microservices, ReactJS, Spring Boot, Apache Kafka, Redis Cache, REST APIs, and Java. </span>
                            I am eager to apply my skills in real-world projects and continue learning in an immersive and collaborative work environment.
                        </span>
                    </div>
                </div>

                {/* Footer Tabs */}
                <div className="box3">
                    <div className="about-footer-box1">
                        <div className="box1-res-footer">
                            <div
                                onClick={() => setActiveTab('responsive')}
                                className={`navlink ${activeTab === 'responsive' ? 'active' : ''}`}
                            >
                                <div className="box1-img">
                                    <img src="responsive.svg" alt="" style={{ width: "20px", height: "20px" }} />
                                </div>
                            </div>
                            <div
                                onClick={() => setActiveTab('expresence')}
                                className={`navlink ${activeTab === 'expresence' ? 'active' : ''}`}
                            >
                                <div className="box2-img">
                                    <img src="expresence.svg" alt="" style={{ width: "20px", height: "20px" }} />
                                </div>
                            </div>
                        </div>
                        <div className="box2-res-footer">
                            <div
                                onClick={() => setActiveTab('design')}
                                className={`navlink ${activeTab === 'design' ? 'active' : ''}`}
                            >
                                <div className="box3-img">
                                    <img src="design.svg" alt="" style={{ width: "20px", height: "20px" }} />
                                </div>
                            </div>
                            <div
                                onClick={() => setActiveTab('permance')}
                                className={`navlink ${activeTab === 'permance' ? 'active' : ''}`}
                            >
                                <div className="box4-img">
                                    <img src="permance.svg" alt="" style={{ width: "20px", height: "20px" }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ✅ Tab Content with Motion Animation */}
                    <div className="about-footer-box2" >
                        <AnimatePresence mode="wait">
                            {activeTab === 'responsive' && (
                                <motion.div
                                    key="responsive"
                                    variants={tabVariants}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                >
                                    <ResponsiveSubPage />
                                </motion.div>
                            )}
                            {activeTab === 'expresence' && (
                                <motion.div
                                    key="expresence"
                                    variants={tabVariants}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                >
                                    <ExpresenceSubPage />
                                </motion.div>
                            )}
                            {activeTab === 'design' && (
                                <motion.div
                                    key="design"
                                    variants={tabVariants}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                >
                                    <DesignSubPage />
                                </motion.div>
                            )}
                            {activeTab === 'permance' && (
                                <motion.div
                                    key="permance"
                                    variants={tabVariants}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                >
                                    <PermanceSubPage />
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </div>
    );
}
